"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRatingEmptyValue = void 0;
const getRatingEmptyValue = () => 0;
exports.getRatingEmptyValue = getRatingEmptyValue;
